module.exports = __webpack_public_path__ + "static/banner-pt-74f8f1d45b5f157c96237c76b17d1066.png";